import $ from 'jquery'

$('.search-filter .submit').click(function() {
  var tags = $('.tags').not('.date');
  var data_ini = $('.tags.date').eq(0).val().split('/');
  var data_fim = $('.tags.date').eq(1).val().split('/');
  var tagsAvailable = [];
  var foundMarkers;
  var markersToShow = [];
  var somenteData = false;

  data_ini = (data_ini.length < 2 ? false : new Date(data_ini[2], data_ini[1] - 1, data_ini[0]));
  data_fim = (data_fim.length < 2 ? false : new Date(data_fim[2], data_fim[1] - 1, data_fim[0]));

  $.each(tags, function() {
    if ($(this).val() === '') return true;
    var tagName = $(this).attr('class').replace('tags', '').replace('hasDatepicker', '').replace('tagit-hidden-field', '').trim();
    var tagValue = $(this).val().split(',');
    tagsAvailable.push({
      'name': tagName,
      'value': tagValue
    });
  });

  if (tagsAvailable.length < 1) {
    somenteData = true;
  } else {
    for (var y = 0; y < tagsAvailable.length; y++) {
      foundMarkers = loadedMarkers.filter(filterMarkers(tagsAvailable[y]));
      markersToShow = markersToShow.concat(foundMarkers);
    }
  }

  // se não tem data na busca, use o filtro assim mesmo
  if (data_ini === false && data_fim === false) {
    var endMarkers = [];
    endMarkers = endMarkers.concat.apply(endMarkers, markersToShow);
    showMarkers(markersToShow);
    return false;
  }

  // Buscar somente por data
  if (markersToShow.length === 0) markersToShow = loadedMarkers;
  var finalMarkers = markersToShow;

  for (var z = 0; z < markersToShow.length; z++) {
    var start = new Date(markersToShow[z].dateTime);
    var end = new Date(markersToShow[z].dateTime_end);
    var except = markersToShow[z].dateTime_except;

    data_ini = (data_ini === false ? new Date(1950, 0, 1) : data_ini);
    data_fim = (data_fim === false ? new Date(2080, 0, 1) : data_fim);

    if (except.length > 0) {
      for (var i = 0; i < except.length; i++) {
        var yearIN = except[i];
        var yearOUT = parseInt(yearIN) + 1;
        except[i] = [];
        except[i].push(new Date(yearIN, 0, 1));
        except[i].push(new Date(yearOUT, 0, 1));
      }
    }

    // Busca se está dentro das datas especificadas
    if (start <= data_fim && end >= data_ini) {
      visible = true;
    } else {
      visible = false;
    }

    // Busca se não se encaixa nas faixas de exclusão
    var isSequence = false;
    var sequenceStart = false;
    if (visible === true) {
      for (var i = 0; i < except.length; i++) {
        if (i > 0) isSequence = (except[i][0].getYear() - except[i - 1][0].getYear() === 1 ? true : false);
        if (!isSequence) {
          if (data_ini >= except[i][0] &&
            data_ini <= except[i][1] &&
            data_fim >= except[i][0] &&
            data_fim <= except[i][1]) {
            visible = false;
            break;
          }
        } else {
          if (!sequenceStart)
            sequenceStart = i - 1;
          if (data_ini >= except[sequenceStart][0] && data_ini <= except[i][1] && data_fim >= except[i][0] && data_fim <= except[i][1]) {
            visible = false;
            break;
          }
        }
      }
    }
    if (visible === false)
      finalMarkers = finalMarkers.filter(filterByDate(markersToShow[z].internalClass));
  }

  showMarkers(finalMarkers);
});

// Filtro checa se algum dos elementos estão presentes num determinado
// filtro. Se qualquer um estiver presente, retorna verdadeiro para exibir.
function filterMarkers(marker) {
  var flag = true;

  return function(element) {
    for (var y = 0; y < marker.value.length; y++) {
      if ($.inArray(marker.value[y], element.filters[marker.name]) > -1)
        return true;
    }
    return false;
  };
}

// Filtro para remover posts com base nas datas buscadas
function filterByDate(marker) {
  return function(element) {
    if (marker === element.internalClass)
      return false;

    return true;
  };
}

function showMarkers(foundMarkers, type) {
  for (var i = 0; i < loadedMarkers.length; i++) {
    loadedMarkers[i].setVisible(false);
    $('.item.' + loadedMarkers[i].internalClass).hide();
  }
  for (var i = 0; i < foundMarkers.length; i++) {
    foundMarkers[i].setVisible(true);
    $('.item.' + foundMarkers[i].internalClass).show();
  }
}

const submitSearchFilters = () => {
  var tags = jQuery('.tags').not('.date');
  var data_ini = jQuery('.tags.date').eq(0).val().split('/');
  var data_fim = jQuery('.tags.date').eq(1).val().split('/');
  var tagsAvailable = [];
  var foundMarkers;
  var markersToShow = [];
  var somenteData = false;

  data_ini = (data_ini.length < 2 ? false : new Date(data_ini[2], data_ini[1] - 1, data_ini[0]));
  data_fim = (data_fim.length < 2 ? false : new Date(data_fim[2], data_fim[1] - 1, data_fim[0]));

  jQuery.each(tags, function() {
    if (jQuery(this).val() === '') return true;

    var tagName = jQuery(this).attr('class')
      .replace('tags', '')
      .replace('hasDatepicker', '')
      .replace('tagit-hidden-field', '')
      .trim();

    var tagValue = jQuery(this).val().split(',');

    tagsAvailable.push({
      'name': tagName,
      'value': tagValue
    });
  });

  if (tagsAvailable.length < 1) {
    somenteData = true;
  } else {
    for (var y = 0; y < tagsAvailable.length; y++) {
      foundMarkers = loadedMarkers.filter(filterMarkers(tagsAvailable[y]));
      markersToShow = markersToShow.concat(foundMarkers);
    }
  }

  // se não tem data na busca, use o filtro assim mesmo
  if (data_ini === false && data_fim === false) {
    var endMarkers = [];
    endMarkers = endMarkers.concat.apply(endMarkers, markersToShow);
    showMarkers(markersToShow);

    return;
  }

  // Buscar somente por data
  if (markersToShow.length === 0) {
    markersToShow = loadedMarkers;
  }

  var finalMarkers = markersToShow;

  for (var z = 0; z < markersToShow.length; z++) {
    var start = new Date(markersToShow[z].dateTime);
    var end = new Date(markersToShow[z].dateTime_end);
    var except = markersToShow[z].dateTime_except;

    data_ini = (data_ini === false ? new Date(1950, 1, 1) : data_ini);
    data_fim = (data_fim === false ? new Date(2080, 1, 1) : data_fim);

    if (except.length > 0) {
      for (var i = 0; i < except.length; i++) {
        var yearIN = except[i];
        var yearOUT = parseInt(yearIN) + 1;
        except[i] = [];
        except[i].push(new Date(yearIN, 0, 1));
        except[i].push(new Date(yearOUT, 0, 1));
      }
    }

    // Busca se está dentro das datas especificadas
    if (start <= data_fim && end >= data_ini) {
      visible = true;
    } else {
      visible = false;
    }

    // Busca se não se encaixa nas faixas de exclusão
    var isSequence = false;
    var sequenceStart = false;
    if (visible === true) {
      for (var i = 0; i < except.length; i++) {
        if (i > 0) {
          isSequence = (except[i][0].getYear() - except[i - 1][0].getYear() === 1 ? true : false);
        }

        if (!isSequence) {
          if (data_ini >= except[i][0] &&
            data_ini <= except[i][1] &&
            data_fim >= except[i][0] &&
            data_fim <= except[i][1]
          ) {
            visible = false;

            break;
          } else {
            if (!sequenceStart) sequenceStart = i - 1;

            if (data_ini >= except[sequenceStart][0] &&
              data_ini <= except[i][1] &&
              data_fim >= except[i][0] &&
              data_fim <= except[i][1]
            ) {
              visible = false;
              break;
            }
          }
        }

        if (visible === false) {
          finalMarkers = finalMarkers.filter(filterByDate(markersToShow[z].internalClass));
        }
      }
    }
  }
  showMarkers(finalMarkers);
}

const selectionFilterCategory = () => {
  const that = event.target

  // Botões de filtro coloridos
  let active = $('.filter-box a.active').length;
  let cls = $(that).attr('class').replace('active', '').trim();
  let visible = [];

  $(that).toggleClass('active');

  $.each($('.filter-box a'), function() {
    let cls = $(this).attr('class').replace('active', '').trim();
    if ($(this).hasClass('active'))
      visible.push(cls);
  });

  for (let i = 0; i < loadedMarkers.length; i++) {
    if (active === 0) {
      loadedMarkers[i].setVisible(false);
      $('.item.' + loadedMarkers[i].internalClass).hide();
    }
    if ($.inArray(cls, visible) > -1) {
      if ($.inArray(cls, loadedMarkers[i].filters.tipo) > -1) {
        loadedMarkers[i].setVisible(true);
        $('.item.' + loadedMarkers[i].internalClass).show();
      }
    } else if (visible.length > 0) {
      if ($.inArray(cls, loadedMarkers[i].filters.tipo) > -1) {
        loadedMarkers[i].setVisible(false);
        $('.item.' + loadedMarkers[i].internalClass).hide();
      }
    } else {
      loadedMarkers[i].setVisible(true);
      $('.item.' + loadedMarkers[i].internalClass).show();
    }

    // Fecha as janelas abertas
    loadedMarkers[i]['infowindow' + loadedMarkers[i].internalClass].close();
  }
  ajustaWrapper();
}

const ajustaWrapper = () => {
  let offsetTop = $('.center-list').offset().top;
  let listHeight = $('.center-list').height();
  let windowHeight = $(window).height();

  if (listHeight <= windowHeight) {
    $('.list-wrapper').css('height', windowHeight + 'px');
  } else if (offsetTop > 0) {
    let totalHeight = (listHeight + offsetTop) + 'px';
    $('.list-wrapper').css('height', totalHeight);
  }
}

$('.filter-box a').on('click', selectionFilterCategory)
$('.search-filter .submit').click(() => submitSearchFilters())